import { isEmpty } from 'lodash'

export const filterByVenueAndOrgName = (
  venueUuid,
  organizationName,
  currentVenueUuid,
  currentOrgName
) => {
  const isVenueAndOrgEmpty = (venueUuid, organizationName) =>
    isEmpty(venueUuid) && isEmpty(organizationName)

  const isVenueAndOrgMatch = (venueUuid, organizationName) =>
    venueUuid === currentVenueUuid &&
    organizationName === currentOrgName

  const isOrgNameMatch = (venueUuid, organizationName) =>
    isEmpty(venueUuid) && organizationName === currentOrgName

  return (
    isVenueAndOrgEmpty(venueUuid, organizationName) ||
    isVenueAndOrgMatch(venueUuid, organizationName) ||
    isOrgNameMatch(venueUuid, organizationName)
  )
}
